import { useTranslation } from "react-i18next";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { registerLinkFormData, registerLinkSchema } from "@/types/forms/bo/registerLinkForm.form";
import { useGenerateLink } from "@/api/auth.api";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { Button } from "@/components/ui/button";
import { ParametersHeader } from "@/components/shared/parametersHeader";

export const GeneralRegisterParameterPage = () => {
  const { t } = useTranslation("boParameters");
  const { mutate: generateLink } = useGenerateLink();

  const { control, handleSubmit, reset } = useForm<registerLinkFormData>({
    resolver: zodResolver(registerLinkSchema),
    mode: "onChange",
    defaultValues: { email: "" },
  });

  const onSubmit: SubmitHandler<registerLinkFormData> = ({ email }) => {
    generateLink(email, {
      onSuccess: () => reset(),
    });
  };

  return (
    <ParametersHeader>
      <div className="flex w-full flex-1 flex-col gap-6 lg:px-8">
        <div className="flex flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
          <div className="flex flex-col items-start gap-2">
            <h2 className="text-lg font-semibold">{t("registerPage.title")}</h2>
            <p className="text-sm text-gray-600">{t("registerPage.description")}</p>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="flex w-full flex-col items-start gap-2">
          <h3 className="text-base font-semibold">{t("registerPage.emailTitle")}</h3>
          <div className="flex flex-row items-start gap-6">
            <ControlledUnifiedInput
              control={control}
              name="email"
              label={t("registerPage.emailLabel")}
              inputType="text"
              className="w-[300px]"
            />
            <Button type="submit">{t("registerPage.submit")}</Button>
          </div>
        </form>
      </div>
    </ParametersHeader>
  );
};
